import { SVGProps } from 'react';

export const CopyIcon2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='25'
    viewBox='0 0 24 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <g opacity='0.7'>
      <path
        d='M10.1335 21.3736H5.4519C4.6501 21.3736 4 20.7236 4 19.9217V5.40307C4 4.60127 4.65 3.95117 5.4519 3.95117H7.6297'
        stroke='#051129'
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.8889 3.95117H17.0667C17.8685 3.95117 18.5186 4.60117 18.5186 5.40307V10.6097'
        stroke='#051129'
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.437 2.5H9.08154C8.27968 2.5 7.62964 3.15004 7.62964 3.9519V4.6777C7.62964 5.47956 8.27968 6.1296 9.08154 6.1296H13.437C14.2389 6.1296 14.8889 5.47956 14.8889 4.6777V3.9519C14.8889 3.15004 14.2389 2.5 13.437 2.5Z'
        stroke='#051129'
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.1218 17.6779L14.6541 18.8271C14.8957 19.0083 15.2407 18.944 15.4008 18.6879L17.58 15.2012'
        stroke='#051129'
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.00903 9.37891H15.1644'
        stroke='#051129'
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.93555 12.1719H10.1333'
        stroke='#051129'
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.6565 22.0001C18.3818 22.0001 20.5911 19.7908 20.5911 17.0655C20.5911 14.3402 18.3818 12.1309 15.6565 12.1309C12.9312 12.1309 10.7219 14.3402 10.7219 17.0655C10.7219 19.7908 12.9312 22.0001 15.6565 22.0001Z'
        stroke='#051129'
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
  </svg>
);
